module.exports = __webpack_public_path__ + "static/media/brand-logo.b4ed5b84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/brand-logo.svg
// module id = 1318
// module chunks = 0